import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getFunctions } from "firebase/functions";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
    apiKey: "AIzaSyA8PPMNbZH_OHb5V6ZBi36z8qRTMUYvXDM",
    authDomain: "kubaya-54f01.firebaseapp.com",
    projectId: "kubaya-54f01",
    storageBucket: "kubaya-54f01.appspot.com",
    messagingSenderId: "775338413469",
    appId: "1:775338413469:web:8341a2fd661f9ea1fff374"
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const auth = getAuth(app);
// Cloud Functions are deployed to europe-west2 (matches the Firestore
// database's region) — must match here or callable/httpsCallable requests
// 404 against the default us-central1 endpoint.
export const functions = getFunctions(app, "europe-west2");
export const storage = getStorage(app);